import TRADCENTER from '@/api/module/trading.js';
const REFUND = {
  namespaced: true,
  state: {

  },
  mutations: {
  },
  actions: {
    // 申请退款
    // eslint-disable-next-line
    async businessRefund({}, params = {}) {
      try {
        const result = await TRADCENTER.businessRefund(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {

  },
};

export default REFUND;